export default "__VITE_ASSET__a99e928b__"